import React from 'react';
import { useIntl } from 'react-intl';
import {
  Alert,
  AlertBody,
  AlertIcon,
} from '@lifeomic/chroma-react/components/Alert';
import { Box } from '@lifeomic/chroma-react/components/Box';
import { Button } from '@lifeomic/chroma-react/components/Button';
import { Text } from '@lifeomic/chroma-react/components/Text';
import { AlertTriangle } from '@lifeomic/chromicons';
import { useMixpanel } from '../../../../hooks';
import { messages } from './messages';

export type OlderAnnualReportBannerProps = {
  newerActiveCarePlanId: string;
  onSwitchToLatest: (carePlanId: string) => void;
};

export const OlderAnnualReportBanner: React.FC<
  OlderAnnualReportBannerProps
> = ({ newerActiveCarePlanId, onSwitchToLatest }) => {
  const { formatMessage } = useIntl();
  const mixpanel = useMixpanel();

  return (
    <Alert statusType="warning" fullWidth>
      <AlertIcon icon={AlertTriangle} />
      <AlertBody>
        <Box direction="row" align="center" gap={1} flexWrap>
          <Text size="subbody">
            {formatMessage(messages.olderAnnualReportWarning)}
          </Text>
          <Button
            variant="text"
            onClick={() => {
              mixpanel.track('annual_report_switch_to_latest_active', {
                carePlanId: newerActiveCarePlanId,
              });
              onSwitchToLatest(newerActiveCarePlanId);
            }}
          >
            {formatMessage(messages.switchToLatestAnnualReport)}
          </Button>
        </Box>
      </AlertBody>
    </Alert>
  );
};

OlderAnnualReportBanner.displayName = 'OlderAnnualReportBanner';
